import BaseForBases from './BaseForBases';

class BaseComponent extends BaseForBases {

    loadOnConstructor(){
    }
}

export default BaseComponent;

